module.exports = __webpack_public_path__ + "static/media/logo.395993a9.png";